import React__default from 'react';
import Box from '../../components/Box/Box.js';
import Spinner from '../../components/Spinner/Spinner.js';

// InnerVisualSlot - can house a leading visual, trailing visual, counter, and loading spinners
// ------------------------
/**
 *
 * Inner visual slot to house leading visual, trailing visual, counter, and loading spinners
 *
 */
const RuleItemInnerVisualSlot = ({
  children,
  hasLoadingIndicator,
  showLoadingIndicator,
  visualPosition
}) => {
  // if there is no inner visual and the Rule Item will never show a loading indicator
  // OR
  // if the visual should render in the leading position, but has neither children nor a loading indicator, return null
  if (!children && !hasLoadingIndicator || visualPosition === 'leading' && !children && !showLoadingIndicator) {
    return null;
  }

  // if the Rule Item will never display a loading indicator, just render the visual
  if (!hasLoadingIndicator) {
    return /*#__PURE__*/React__default.createElement("span", {
      className: "rule-item-visual"
    }, /*#__PURE__*/React__default.createElement(Box, {
      sx: {
        display: 'flex',
        alignItems: 'center',
        gap: 2
      }
    }, children));
  }

  // else, do this:
  // is the Rule Item in a loading state? If yes, show a spinner in the visual position based on the loadingPosition prop; if not, just render the visual.
  return /*#__PURE__*/React__default.createElement("span", {
    className: "rule-item-visual"
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      position: 'relative'
    }
  }, children && !showLoadingIndicator && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      gap: 2
    }
  }, children), children && showLoadingIndicator && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      gap: 2
    }
  }, /*#__PURE__*/React__default.createElement(Spinner, {
    "aria-label": 'Loading',
    sx: children ? {
      position: 'absolute',
      top: 0,
      height: '100%',
      maxWidth: '100%',
      visibility: 'visible',
      ...(visualPosition === 'leading' ? {
        left: '0px'
      } : {
        right: '0px'
      })
    } : {
      visibility: 'visible'
    },
    size: children ? undefined : 'small'
  }))));
};
RuleItemInnerVisualSlot.displayName = "RuleItemInnerVisualSlot";

export { RuleItemInnerVisualSlot };
